import { DefaultService } from '@/services/DefaultService';

export default class PermissaoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(permissao) {
        return this._http.post(`${this._env}/authorization`, permissao, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id, nomeClienteSovis) {
        return this._http.get(`${this._env}/authorization/${id}.json?nome_cliente_sovis=${nomeClienteSovis}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    
}